import Component from "../classes/Component";
import $ from "jquery";
import "magnific-popup";
import "magnific-popup/dist/magnific-popup.css"

export default class Popin extends Component {
  constructor() {
    super({});
    this.element = [
      ...document.querySelectorAll("[data-components-popin-toggle]"),
    ];
    this.elements = {
      videoPopin: [...document.querySelectorAll('[data-popin-video]')],
      cgvPopin: document.querySelector("#popin__cgv"),
      youtobePopin: $(".popup-youtube"),
      memberPopin: $('.open-popup-link'),
    };
    this.init();
  }

  init() {
    if (this.element) {
      this.listenPopin();
    }
    if (this.elements.youtobePopin.length) {
      this.elements.youtobePopin.magnificPopup({
        type: 'iframe',
        iframe: this.extendMagnificIframe(),
      });
    }
    if (this.elements.memberPopin.length) {
      this.elements.memberPopin.magnificPopup({
        type: 'inline',
        midClick: true,
        mainClass: 'mfp-fade'
      });
    }
  }

  extendMagnificIframe() {
    var $start = 0;
    var $iframe = {
      markup: '<div class="mfp-iframe-scaler">' +
        '<div class="mfp-close"></div>' +
        '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
        '</div>' +
        '<div class="mfp-bottom-bar">' +
        '<div class="mfp-title"></div>' +
        '</div>',
      patterns: {
        youtube: {
          index: 'youtu',
          id: function (url) {

            var m = url.match(/^.*(?:youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/);
            if (!m || !m[1]) return null;

            if (url.indexOf('t=') != -1) {

              var $split = url.split('t=');
              var hms = $split[1].replace('h', ':').replace('m', ':').replace('s', '');
              var a = hms.split(':');

              if (a.length == 1) {

                $start = a[0];

              } else if (a.length == 2) {

                $start = (+a[0]) * 60 + (+a[1]);

              } else if (a.length == 3) {

                $start = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);

              }
            }

            var suffix = '?autoplay=1';

            if ($start > 0) {

              suffix = '?start=' + $start + '&autoplay=1';
            }

            return m[1] + suffix;
          },
          src: '//www.youtube.com/embed/%id%'
        },
        vimeo: {
          index: 'vimeo.com/',
          id: function (url) {
            var m = url.match(/(https?:\/\/)?(www.)?(player.)?vimeo.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/);
            if (!m || !m[5]) return null;
            return m[5];
          },
          src: '//player.vimeo.com/video/%id%?autoplay=1'
        }
      }
    };

    return $iframe;

  }

  listenPopin() {
    this.element.forEach((el) => {
      el.addEventListener("click", (e) => {
        if (this.elements.videoPopin) {
          this.showPopinVideo(el);
          e.stopPropagation();
          e.preventDefault();
        }
        if (this.elements.cgvPopin) {
          this.showPopin();
        }
      });
    });
  }

  showPopinVideo(el) {
    this.elements.videoPopin.forEach(video => {
      if (el.dataset.id === video.dataset.id) video.classList.toggle("css-show");
    });

  }

  showPopin() {
    this.elements.cgvPopin.classList.toggle("css-show");
  }

}


